
        <div [formGroup]="form">
            <!-- Row 1: Description -->
            <div class="row">
              <div class="col-md-12">
                <div class="form-group mb-3">
                  <label for="description" class="form-label">{{ labels.describeRequest }} <span class="ast">*</span></label>
                  <textarea
                    id="description"
                    class="form-control"
                    formControlName="description"
                    [class.is-invalid]="isFieldInvalid('description')"
                    rows="4"
                    placeholder="Describe your request here..." maxlength="2000"></textarea>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('description')">
                    <span *ngIf="form.get('description')?.hasError('required')">
                       {{ messages.fieldRequired }}
                    </span>
                    <span *ngIf="form.get('description')?.hasError('minlength')">
                      {{ messages.characterLimit }}
                    </span>
                  </div>
              </div>
            </div>
        </div>
